/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Portal } from 'components';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;

	> h4 {
		text-align: center;
		margin: 0 !important;
	}

	> div {
		display: flex;
		flex-direction: column;
		gap: 20px;

		@media (min-width: 660px) {
			flex-direction: row;
			justify-content: space-between;
		}

		> * {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 20px;
			font-weight: 500 !important;
			font-size: 14px !important;
			line-height: 100% !important;
			text-transform: uppercase !important;
			color: ${props => props.theme.darkBlue};
			cursor: pointer;

			&:hover {
				color: ${props => props.theme.lightBlue};
			}

			@media (min-width: 660px) {
				width: 160px;
			}
		}
	}
`;

const IconBuyer = () => (
	<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M33.3949 76.6329C32.081 75.319 29.7346 75.319 28.4206 76.6329L3.07963 101.997C-1.02654 106.104 -1.02654 112.814 3.07963 116.92C7.1858 121.027 13.8965 121.027 18.0026 116.92L43.3671 91.556C44.7514 90.1716 44.7514 87.9425 43.3671 86.5816L33.3949 76.6329Z" fill="url(#paint0_linear_2753_1767)"/>
		<path d="M77.7651 84.4699C101.091 84.4699 120 65.5606 120 42.2349C120 18.9092 101.091 0 77.7651 0C54.4393 0 35.5301 18.9092 35.5301 42.2349C35.5301 65.5606 54.4393 84.4699 77.7651 84.4699Z" fill="url(#paint1_linear_2753_1767)"/>
		<path d="M66.8075 58.6596C69.8343 58.6596 72.298 56.1959 72.298 53.1691V47.6786H83.2556V53.1691C83.2556 56.1959 85.7193 58.6596 88.7462 58.6596C91.773 58.6596 94.2367 56.1959 94.2367 53.1691V31.2773C94.2367 28.2505 91.773 25.7868 88.7462 25.7868C85.7193 25.7868 83.2556 28.2505 83.2556 31.2773V36.7679H72.298V31.2773C72.298 28.2505 69.8343 25.7868 66.8075 25.7868C63.7806 25.7868 61.3169 28.2505 61.3169 31.2773V53.1691C61.3169 56.2194 63.7806 58.6596 66.8075 58.6596Z" fill="url(#paint2_linear_2753_1767)"/>
		<defs>
			<linearGradient id="paint0_linear_2753_1767" x1="3.6232" y1="116.434" x2="108.298" y2="11.4537" gradientUnits="userSpaceOnUse">
				<stop stopColor="#5558FF"/>
				<stop offset="1" stopColor="#00C0FF"/>
			</linearGradient>
			<linearGradient id="paint1_linear_2753_1767" x1="3.58261" y1="116.634" x2="108.258" y2="11.6533" gradientUnits="userSpaceOnUse">
				<stop stopColor="#5558FF"/>
				<stop offset="1" stopColor="#00C0FF"/>
			</linearGradient>
			<linearGradient id="paint2_linear_2753_1767" x1="77.7621" y1="58.6625" x2="77.7621" y2="25.8131" gradientUnits="userSpaceOnUse">
				<stop stopColor="#ADDCFF"/>
				<stop offset="0.5028" stopColor="#EAF6FF"/>
				<stop offset="1" stopColor="#EAF6FF"/>
			</linearGradient>
		</defs>
	</svg>
);

const IconSupplier = () => (
	<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M95.1562 35.3906H84.6094V3.51562C84.6094 1.57406 83.0353 0 81.0938 0H38.9062C36.9647 0 35.3906 1.57406 35.3906 3.51562V35.3906H28.3594C24.476 35.3906 21.3281 38.5387 21.3281 42.4219V88.991C21.3281 90.5084 22.3041 91.8248 23.7356 92.328C26.5022 93.3002 28.3594 95.94 28.3594 98.9062C28.3594 99.6959 28.1672 100.465 27.8857 101.378C27.5562 102.446 28.0643 103.606 28.7304 104.506C29.3895 105.405 30.7559 105.938 31.875 105.938C33.8114 105.938 35.3906 107.513 35.3906 109.453C35.3906 111.393 33.8114 112.969 31.875 112.969C29.9318 112.969 28.3594 114.541 28.3594 116.484C28.3594 118.428 29.9318 120 31.875 120H49.4531C53.3365 120 56.4844 116.852 56.4844 112.969V98.9062H63.5156V112.969C63.5156 116.852 66.6635 120 70.5469 120H88.125C90.0682 120 91.6406 118.428 91.6406 116.484C91.6406 114.541 90.0682 112.969 88.125 112.969C86.1886 112.969 84.6094 111.393 84.6094 109.453C84.6094 107.513 86.1886 105.938 88.7566 105.938C89.8758 105.938 90.9265 105.405 91.5855 104.506C92.2516 103.606 92.4438 102.446 92.1143 101.378C91.8328 100.465 91.6406 99.6959 91.6406 98.9062C91.6406 95.94 93.4978 93.3002 96.2644 92.328C97.6957 91.8251 98.6719 90.5084 98.6719 88.991V38.9062C98.6719 36.9647 97.0978 35.3906 95.1562 35.3906Z" fill="url(#paint0_linear_2753_1758)"/>
		<path d="M52.9688 35.3906C54.912 35.3906 56.4844 33.8182 56.4844 31.875V28.3594H63.5156V31.875C63.5156 33.8182 65.088 35.3906 67.0312 35.3906C68.9745 35.3906 70.5469 33.8182 70.5469 31.875V17.8125C70.5469 15.8693 68.9745 14.2969 67.0312 14.2969C65.088 14.2969 63.5156 15.8693 63.5156 17.8125V21.3281H56.4844V17.8125C56.4844 15.8693 54.912 14.2969 52.9688 14.2969C51.0255 14.2969 49.4531 15.8693 49.4531 17.8125V31.875C49.4531 33.8182 51.0255 35.3906 52.9688 35.3906ZM38.9062 56.7188H81.0938C83.037 56.7188 84.6094 55.1463 84.6094 53.2031C84.6094 51.2599 83.037 49.6875 81.0938 49.6875H38.9062C36.963 49.6875 35.3906 51.2599 35.3906 53.2031C35.3906 55.1463 36.963 56.7188 38.9062 56.7188ZM38.9062 70.7812H81.0938C83.037 70.7812 84.6094 69.2088 84.6094 67.2656C84.6094 65.3224 83.037 63.75 81.0938 63.75H38.9062C36.963 63.75 35.3906 65.3224 35.3906 67.2656C35.3906 69.2088 36.963 70.7812 38.9062 70.7812ZM38.9062 84.8438H81.0938C83.037 84.8438 84.6094 83.2713 84.6094 81.3281C84.6094 79.3849 83.037 77.8125 81.0938 77.8125H38.9062C36.963 77.8125 35.3906 79.3849 35.3906 81.3281C35.3906 83.2713 36.963 84.8438 38.9062 84.8438ZM67.0312 91.875H52.9688C51.0272 91.875 49.4531 93.4491 49.4531 95.3906V120H70.5469V95.3906C70.5469 93.4491 68.9728 91.875 67.0312 91.875ZM35.37 99.6066C35.73 93.6684 32.0393 87.7542 26.0796 85.6985C24.5416 85.1252 22.9898 84.8438 21.3281 84.8438C13.6195 84.8438 6.98719 91.177 7.27945 99.5037C3.18 100.949 0 104.863 0 109.453C0 115.269 4.96547 120 10.7812 120H31.875C37.6908 120 42.4219 115.269 42.4219 109.453C42.4219 104.969 39.6136 101.131 35.37 99.6066ZM112.714 99.6066C113.188 91.7789 106.811 84.8438 98.6719 84.8438C97.0102 84.8438 95.4584 85.1252 94.0095 85.6678C88.4046 87.6012 84.3949 93.0045 84.623 99.5037C80.5238 100.949 77.5781 104.863 77.5781 109.453C77.5781 115.269 82.3092 120 88.125 120H109.219C115.035 120 120 115.269 120 109.453C120 104.969 116.957 101.131 112.714 99.6066Z" fill="url(#paint1_linear_2753_1758)"/>
		<defs>
			<linearGradient id="paint0_linear_2753_1758" x1="60" y1="120" x2="60" y2="0" gradientUnits="userSpaceOnUse">
				<stop stopColor="#00B59C"/>
				<stop offset="1" stopColor="#9CFFAC"/>
			</linearGradient>
			<linearGradient id="paint1_linear_2753_1758" x1="60" y1="120" x2="60" y2="14.2969" gradientUnits="userSpaceOnUse">
				<stop stopColor="#C3FFE8"/>
				<stop offset="0.9973" stopColor="#F0FFF4"/>
			</linearGradient>
		</defs>
	</svg>
);

const IconInner = () => (
	<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z" fill="url(#paint0_linear_2753_1753)"/>
		<path d="M45 60C53.2843 60 60 66.7157 60 75H30C30 66.7157 36.7157 60 45 60ZM45 45C49.1421 45 52.5 48.3579 52.5 52.5C52.5 56.6421 49.1421 60 45 60C40.8579 60 37.5 56.6421 37.5 52.5C37.5 48.3579 40.8579 45 45 45Z" fill="url(#paint1_linear_2753_1753)"/>
		<path d="M75 60C83.2843 60 90 66.7157 90 75H60C60 66.7157 66.7157 60 75 60ZM75 45C79.1421 45 82.5 48.3579 82.5 52.5C82.5 56.6421 79.1421 60 75 60C70.8579 60 67.5 56.6421 67.5 52.5C67.5 48.3579 70.8579 45 75 45Z" fill="url(#paint2_linear_2753_1753)"/>
		<defs>
			<linearGradient id="paint0_linear_2753_1753" x1="-45.3854" y1="165.693" x2="103.319" y2="16.555" gradientUnits="userSpaceOnUse">
				<stop stopColor="#5558FF"/>
				<stop offset="1" stopColor="#00C0FF"/>
			</linearGradient>
			<linearGradient id="paint1_linear_2753_1753" x1="45" y1="45" x2="45" y2="75" gradientUnits="userSpaceOnUse">
				<stop stopColor="white"/>
				<stop offset="1" stopColor="#C5E6FF"/>
			</linearGradient>
			<linearGradient id="paint2_linear_2753_1753" x1="75" y1="45" x2="75" y2="75" gradientUnits="userSpaceOnUse">
				<stop stopColor="white"/>
				<stop offset="1" stopColor="#C5E6FF"/>
			</linearGradient>
		</defs>
	</svg>
);

const Login = ({ children = null, initialIsOpen = false }) => {
	const { t } = useTranslation();
	const [ isOpen, setOpen ] = useState(initialIsOpen);

	return (
		<>
			{React.cloneElement(children, { onClick: () => setOpen(true) })}

			{isOpen && <Portal isOpen width='620' onClose={() => setOpen(false)}>
				<Container>
					<h4>{t('Вход в личный кабинет')}</h4>

					<div>
						<a href='https://b2b.acase.ru'>
							<IconBuyer />
							{t('Для агентов')}
						</a>

						<a href='https://hotel.acase.ru'>
							<IconSupplier />
							{t('Для отелей')}
						</a>

						<a href='https://staff.acase.ru'>
							<IconInner />
							{t('Для сотрудников')}
						</a>
					</div>
				</Container>
			</Portal>}
		</>
	);
};

export default Login;